
import isEmpty from 'lodash/isEmpty'

export const MODEL_VARIANTS = {
  LARGE: 'large',
  SMALL: 'small',
}

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      validator: (variant) => Object.values(MODEL_VARIANTS).includes(variant),
      default: MODEL_VARIANTS.LARGE,
    },
  },

  computed: {
    displaySubTitle() {
      return !isEmpty(this.subTitle)
    },

    subTitleLabel() {
      return this.displaySubTitle && this.subTitle.join(' - ')
    },

    isSmallVariant() {
      return this.variant === MODEL_VARIANTS.SMALL
    },

    titleClass() {
      return {
        'title-1': !this.isSmallVariant,
        'body-1-bold': this.isSmallVariant,
      }
    },
  },
}
